import React from 'react';
import SkillsReportRouter from '../containers/SkillsReportRouter';
import DemoAccountContextProvider from '../contexts/DemoAccountContextProvider';

export default ({ isDemo = false, ...props }) => (
  <DemoAccountContextProvider isDemo={isDemo}>
    <SkillsReportRouter {...props} />
  </DemoAccountContextProvider>
);
